module.exports = __webpack_public_path__ + "img/case5.36aadf45.svg";